import React from 'react';
import config from '../../util/js/config';
// import Navbar1 from './1/Navbar1';
import Navbar2 from './2/Navbar2';

import Radium from 'radium';

const NavbarArray = {
    // "1": Navbar1,
    "2": Navbar2
}

class Navbar extends React.Component {
    render() {
        const navbarConfig = config.navbar || 1;
        const NavbarView = NavbarArray[navbarConfig]
        return (
            <NavbarView />
        );
    }
};

export default Radium(Navbar);




// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js